export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              移动观影 · 随时随地追剧
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
              被窝网电影完美适配手机与平板浏览器，无需下载安装，打开即用。
              HTML5播放器自动适配屏幕尺寸，横屏竖屏自由切换，地铁上、被窝里随时随地畅享高清影视。
              收藏本站到手机桌面，一键直达观影入口。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机端观影指南
              </a>
              <span className="text-sm text-background-50/70 whitespace-nowrap">
                支持 iOS · Android · iPad
              </span>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-50/15 flex items-center justify-center">
              <i className="ri-smartphone-line text-6xl md:text-7xl text-background-50/60"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}